import { useContext } from "react"

import { UserDataContext } from "../providers/userDataProvider"

export interface IUserData {
    groups: string[]
    displayGroups: string[]
    firstName: string
    lastName: string
    hasSetMfa: boolean
    email: string
    username: string
    isAwaitingSetup: boolean
    isSetUpPending: boolean
    isSignedIn: boolean
    isConfiguring: boolean
    isMfaRequired: boolean
    isDnoApproved: boolean
    isDnoAdmin: boolean
    isInstallerAdmin: boolean
    isInstaller: boolean
    isManuAdmin: boolean
    isEnaSysAdmin: boolean
    isManuApproved: boolean
    isGenAssessor: boolean
    isDemandAssessor: boolean
    isV2gAssessor: boolean
    showUnapprovedWarning: boolean
    isDnoUnapproved: boolean
    isInstallerUnapproved: boolean
    isManuUnapproved: boolean
    isIDno: boolean
    onSignOut: () => void
    isManufacturerForDevice: (deviceRef: string) => boolean
}

/**
 * Hook for accessing user data from the UserDataProvider context.
 * All Cognito API calls happen once in the provider — this hook
 * is a zero-cost context read.
 *
 * @returns IUserData — user groups, attributes, flags, and actions
 */
export const useGetUserData = (): IUserData => useContext(UserDataContext)
